import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'

import Checkup from '@src/data/checkup'
import { API } from '@src/lib/api_path'
import { snakecaseKeys } from '@src/util/functions'
import ApiClient from '@src/lib/api_client'
import { H5 } from '@src/elements/typography/typography'

type CheckupResponse = { checkup: Checkup }

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    }
  }
})
export default class Completed extends Vue {

  @Prop({ required: false, default: false })
  private isReadonly: boolean

  private checkup: Checkup

  private apiClient: ApiClient

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }

  updated () {
    if (!this.isReadonly) {
      this.completeCheckup()
    }
  }

  completeCheckup () {
    // mark the checkup as completed
    if (!this.checkup.isComplete()) {
      let checkup = new Checkup(this.checkup)
      checkup.forceComplete()

      this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
        .then((response: CheckupResponse) => {
          this.$store.dispatch('setCheckup', new Checkup(camelcaseKeys(response.checkup, { deep: true })))
        })
        .catch(err => console.error('Failed to update checkup, ', err))
    }
  }

  render (h: CreateElement) {

    return <div class='onboarding-completed'>
      <H5>{this.$t('PAGE.MEMBERS.CHECKUPS.CHECKUP_ADDED')}</H5>
    </div>
  }
}
